<div fxLayout="column" style="padding:15px;" fxLayoutAlign="center center center">
    <mat-card ngStyle.gt-lg="width:76%;" ngStyle.lg="width:76%;" ngStyle.lt-lg="width:100%;">
        <mat-card-title>
            <app-page-header [title]="pageTitle" action=''></app-page-header>

        </mat-card-title>
        <mat-card-content fxLayout="column">

            <div fxLayout="column" fxFlex="grow" fxLayoutAlign="start center center" style="margin-top:50px;">
                <div fxLayout="row" fxLayoutGap="20px" fxFlex="grow" fxFlex="grow" ngStyle.md="width:90%"
                     ngStyle.lt-md="width:100%"
                     ngStyle.gt-md="width:100%">
                    <div fxFlexAlign="center">Γρήγορη Αναζήτηση</div>
                    <div fxFlexAlign="center" fxLayoutGap="20px">
                        <mat-form-field>
                            <mat-label>Κριτήριο Αναζήτησης</mat-label>
                            <mat-select [(ngModel)]="simpleSearchSelectedValue">
                                <mat-option *ngFor="let searchField of parentSearchFields"
                                            [value]="searchField">{{searchField.label}}</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Όνομα</mat-label>
                            <input matInput [(ngModel)]="searchValue" (keydown)="fastSearch($event) ">
                            <button mat-button matSuffix mat-icon-button aria-label="search" (click)="search()">
                                <mat-icon fxFlexAlign="center" matTooltip="Αναζήτηση">search</mat-icon>
                            </button>
                            <!--          <mat-icon fxFlexAlign="center" (click)="search()" matTooltip="Αναζήτηση">search</mat-icon>-->
                        </mat-form-field>
                    </div>

                    <mat-icon fxFlexAlign="center" (click)="showSearchDialog()" matTooltip="Σύνθετη αναζήτηση">
                        person_search
                    </mat-icon>


                    <div fxLayoutAlign.gt-sm="end center center" fxLayoutAlign.lt-md="center stretch"
                         fxFlex.lt-md="100">
                        <button ngStyle.lt-md="width:100%;"
                                style="background: var(--primary); color:white; font-weight: normal; vertical-align: middle; border-radius: 50px;"
                                mat-flat-button [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger">
                            Ενέργειες
                            &nbsp;
                            <mat-icon style="vertical-align: middle; color:white;">
                                {{menuTrigger.menuOpen ? 'expand_less' : 'expand_more'}}
                            </mat-icon>
                        </button>

                        <mat-menu #menu="matMenu">

                            <mat-list class="menuList">
                                <mat-list-item class="menuList">
                                    <button mat-menu-item [disabled]="this.selection.selected.length === 0"
                                            (click)="initFormProc()">
                                        <mat-icon class="icon">description</mat-icon>&nbsp;Δημοσίευση δήλωσης
                                    </button>
                                </mat-list-item>
                            </mat-list>

                            <mat-list class="menuList">
                                <mat-list-item class="menuList">
                                    <button mat-menu-item (click)="exportToExcel()">
                                        <mat-icon class="icon">description</mat-icon>&nbsp;Εξαγωγή σε xlsx
                                    </button>
                                </mat-list-item>
                            </mat-list>

                            <mat-list class="menuList">
                                <mat-list-item class="menuList">
                                    <button mat-menu-item (click)="exportToPDF()">
                                        <mat-icon class="icon">picture_as_pdf</mat-icon>&nbsp;Εξαγωγή σε pdf
                                    </button>
                                </mat-list-item>
                            </mat-list>
                            <!--          <mat-list class="menuList">-->
                            <!--            <mat-list-item class="menuList" >-->
                            <!--              <button mat-menu-item>-->
                            <!--                <mat-icon class="icon">email</mat-icon>&nbsp; Προσθήκη pdf σε email-->
                            <!--              </button>-->
                            <!--            </mat-list-item>-->
                            <!--          </mat-list>-->
                        </mat-menu>
                    </div>
                </div>

                <div fxLayout="row" fxFlex="grow" style="margin-top:5px;" ngStyle.md="width:90%"
                     ngStyle.lt-md="width:100%"
                     ngStyle.gt-md="width:100%">

                    <div fxLayout="column" fxFlex="grow" fxLayoutAlign="start" #tableContainer>

                        <div fxLayout="row" fxLayoutAlign="flex-end" fxFlex="grow" style="margin-bottom: 10px;">
                            <label><u>Επιλεγμένοι <b>{{selection.selected.length}}</b> χρήστες</u></label>
                        </div>

                        <div fxLayout="row" [style.max-height.px]=" isLoading ? 50 : tableHeight">
                            <mat-table [dataSource]="parents" matSort style="width:100%; overflow: auto;"
                                       [style.max-height.px]=" isLoading ? 50 : tableHeight">

                                <ng-container matColumnDef="select">
                                    <mat-header-cell *matHeaderCellDef fxFlex="5" fxLayoutAlign="start center center">
                                        <mat-checkbox (change)="$event ? masterToggle() : null"
                                                      [checked]="selection.hasValue() && isAllSelected()"
                                                      [indeterminate]="selection.hasValue() && !isAllSelected()">
                                        </mat-checkbox>
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let row" fxFlex="5" fxLayoutAlign="start center center">
                                        <mat-checkbox (click)="$event.stopPropagation()"
                                                      (change)="$event ? selection.toggle(row) : null"
                                                      [checked]="selection.isSelected(row)">
                                        </mat-checkbox>
                                    </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="firstName">
                                    <mat-header-cell class="tableHeaderCell" *matHeaderCellDef mat-sort-header
                                                     fxLayoutAlign="start center center"> Όνομα
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let parent"
                                              fxLayoutAlign="start center center"> {{parent.firstName}} </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="lastName">
                                    <mat-header-cell class="tableHeaderCell" *matHeaderCellDef mat-sort-header
                                                     fxLayoutAlign="start center center">
                                        Επώνυμο
                                    </mat-header-cell>
                                    <mat-cell class="tableCell" *matCellDef="let parent"
                                              fxLayoutAlign="start center center"> {{parent.lastName}} </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="email">
                                    <mat-header-cell class="tableHeaderCell" *matHeaderCellDef
                                                     fxLayoutAlign="start center center"> Email
                                    </mat-header-cell>
                                    <mat-cell class="tableCell" *matCellDef="let parent"
                                              fxLayoutAlign="start center center"> {{parent.email}} </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="telephone">
                                    <mat-header-cell class="tableHeaderCell" *matHeaderCellDef
                                                     fxLayoutAlign="start center center"> Τηλέφωνο
                                    </mat-header-cell>
                                    <mat-cell class="tableCell" *matCellDef="let parent"
                                              fxLayoutAlign="start center center"> {{parent.telephone}} </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="is_valid">
                                    <mat-header-cell class="tableHeaderCell" *matHeaderCellDef
                                                     fxLayoutAlign="start center center"> Κατάσταση
                                    </mat-header-cell>
                                    <mat-cell class="tableCell" *matCellDef="let parent"
                                              fxLayoutAlign="start center center"> {{+parent.is_valid === 1 ? 'Ενεργός' : 'Ανενεργός'}} </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="actions">
                                    <mat-header-cell class="tableHeaderCell" *matHeaderCellDef
                                                     fxLayoutAlign="center center center"> Ενέργειες
                                    </mat-header-cell>
                                    <mat-cell class="tableCell" *matCellDef="let parent"
                                              fxLayoutAlign="center center center">
                                        <div #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu"
                                             style="cursor: pointer; align-content: center;">
                                            <div fxLayout="row" fxFlexAlign="center">
                                                <mat-icon
                                                        style="align-content:center; vertical-align: middle; color:var(--secondaryBlue)">
                                                    more_vert
<!--                                                    {{menuTrigger.menuOpen ? 'expand_less' : 'expand_more'}}-->
                                                </mat-icon>
                                            </div>
                                        </div>

                                        <mat-menu #menu="matMenu">
                                            <mat-list>
                                                <mat-list-item class="menuList">
                                                    <button mat-menu-item (click)="getParentInfo(parent)">
                                                        <mat-icon class="icon">info</mat-icon>&nbsp;Προβολή πληροφοριών
                                                    </button>
                                                </mat-list-item>
                                                <mat-list-item class="menuList">
                                                    <button mat-menu-item (click)="sendEmail(parent)">
                                                        <mat-icon class="icon">message</mat-icon>&nbsp;Αποστολή
                                                        ενημέρωσης
                                                    </button>
                                                </mat-list-item>
                                                <!--                <mat-list-item class="menuList">-->
                                                <!--                  <button mat-menu-item>-->
                                                <!--                  <mat-icon class="icon">message</mat-icon>&nbsp;Αποστολή SMS-->
                                                <!--                  </button>-->
                                                <!--                </mat-list-item>-->
                                                <mat-list-item class="menuList">
                                                    <button mat-menu-item (click)="sendMessage(parent)">
                                                        <mat-icon class="icon">notifications</mat-icon>&nbsp;Αποστολή
                                                        ειδοποίησης
                                                    </button>
                                                </mat-list-item>
                                            </mat-list>
                                        </mat-menu>

                                    </mat-cell>
                                </ng-container>

                                <mat-header-row *matHeaderRowDef="columnsToDisplay"></mat-header-row>
                                <mat-row *matRowDef="let record; columns: columnsToDisplay"></mat-row>
                            </mat-table>
                        </div>

                        <div *ngIf="isLoading">
                            <app-skeleton-loading></app-skeleton-loading>
                        </div>

                        <div fxLayout="row" fxLayoutAlign="end center center">
                            <mat-paginator [length]="parents.data.length" [pageSize]="50"
                                           [pageSizeOptions]="[10, 50, 100, 200]">
                            </mat-paginator>
                        </div>

                    </div>

                </div>

            </div>


<!--            <div fxShow.gt-sm fxHide.lt-md fxLayout="column" fxFlex="grow" fxLayoutAlign="center center center"-->
<!--                 style="margin-top:50px;">-->
<!--                <div fxLayout="row" fxLayoutGap="20px" fxFlex="grow" ngStyle.lt-md="width:100%;"-->
<!--                     ngStyle.gt-sm="width:90%;">-->
<!--                    <div fxFlexAlign="center">Γρήγορη Αναζήτηση</div>-->
<!--                    <div fxFlexAlign="center" fxLayoutGap="20px">-->
<!--                        <mat-form-field>-->
<!--                            <mat-label>Κριτήριο Αναζήτησης</mat-label>-->
<!--                            <mat-select [(ngModel)]="simpleSearchSelectedValue">-->
<!--                                <mat-option *ngFor="let searchField of parentSearchFields"-->
<!--                                            [value]="searchField">{{searchField.label}}</mat-option>-->
<!--                            </mat-select>-->
<!--                        </mat-form-field>-->

<!--                        <mat-form-field>-->
<!--                            <mat-label>Όνομα</mat-label>-->
<!--                            <input matInput [(ngModel)]="searchValue" (keydown)="fastSearch($event) ">-->
<!--                            <button mat-button matSuffix mat-icon-button aria-label="search" (click)="search()">-->
<!--                                <mat-icon fxFlexAlign="center" matTooltip="Αναζήτηση">search</mat-icon>-->
<!--                            </button>-->
<!--                            &lt;!&ndash;          <mat-icon fxFlexAlign="center" (click)="search()" matTooltip="Αναζήτηση">search</mat-icon>&ndash;&gt;-->
<!--                        </mat-form-field>-->
<!--                    </div>-->

<!--                    <mat-icon fxFlexAlign="center" (click)="showSearchDialog()" matTooltip="Σύνθετη αναζήτηση">-->
<!--                        person_search-->
<!--                    </mat-icon>-->


<!--                    <div fxLayoutAlign.gt-sm="end center center" fxLayoutAlign.lt-md="center stretch"-->
<!--                         fxFlex.lt-md="100">-->
<!--                        <button ngStyle.lt-md="width:100%;"-->
<!--                                style="background: var(&#45;&#45;primary); color:white; font-weight: normal; vertical-align: middle; border-radius: 50px;"-->
<!--                                mat-flat-button [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger">-->
<!--                            Ενέργειες-->
<!--                            &nbsp;-->
<!--                            <mat-icon style="vertical-align: middle; color:white;">-->
<!--                                {{menuTrigger.menuOpen ? 'expand_less' : 'expand_more'}}-->
<!--                            </mat-icon>-->
<!--                        </button>-->

<!--                        <mat-menu #menu="matMenu">-->

<!--                            <mat-list class="menuList">-->
<!--                                <mat-list-item class="menuList">-->
<!--                                    <button mat-menu-item (click)="exportToExcel()">-->
<!--                                        <mat-icon class="icon">description</mat-icon>&nbsp;Εξαγωγή σε xlsx-->
<!--                                    </button>-->
<!--                                </mat-list-item>-->
<!--                            </mat-list>-->

<!--                            <mat-list class="menuList">-->
<!--                                <mat-list-item class="menuList">-->
<!--                                    <button mat-menu-item (click)="exportToPDF()">-->
<!--                                        <mat-icon class="icon">picture_as_pdf</mat-icon>&nbsp;Εξαγωγή σε pdf-->
<!--                                    </button>-->
<!--                                </mat-list-item>-->
<!--                            </mat-list>-->
<!--                            &lt;!&ndash;          <mat-list class="menuList">&ndash;&gt;-->
<!--                            &lt;!&ndash;            <mat-list-item class="menuList" >&ndash;&gt;-->
<!--                            &lt;!&ndash;              <button mat-menu-item>&ndash;&gt;-->
<!--                            &lt;!&ndash;                <mat-icon class="icon">email</mat-icon>&nbsp; Προσθήκη pdf σε email&ndash;&gt;-->
<!--                            &lt;!&ndash;              </button>&ndash;&gt;-->
<!--                            &lt;!&ndash;            </mat-list-item>&ndash;&gt;-->
<!--                            &lt;!&ndash;          </mat-list>&ndash;&gt;-->
<!--                        </mat-menu>-->
<!--                    </div>-->
<!--                </div>-->


<!--                <div fxLayout="column" fxFlex="grow" ngStyle.lt-md="width:100%;" ngStyle.gt-sm="width:90%;">-->
<!--                    <mat-table [dataSource]="parents" matSort style="width:100%;">-->

<!--                        <ng-container matColumnDef="select">-->
<!--                            <mat-header-cell *matHeaderCellDef fxFlex="5" fxLayoutAlign="start center center">-->
<!--                                <mat-checkbox (change)="$event ? masterToggle() : null"-->
<!--                                              [checked]="selection.hasValue() && isAllSelected()"-->
<!--                                              [indeterminate]="selection.hasValue() && !isAllSelected()">-->
<!--                                </mat-checkbox>-->
<!--                            </mat-header-cell>-->
<!--                            <mat-cell *matCellDef="let row" fxFlex="5" fxLayoutAlign="start center center">-->
<!--                                <mat-checkbox (click)="$event.stopPropagation()"-->
<!--                                              (change)="$event ? selection.toggle(row) : null"-->
<!--                                              [checked]="selection.isSelected(row)">-->
<!--                                </mat-checkbox>-->
<!--                            </mat-cell>-->
<!--                        </ng-container>-->

<!--                        <ng-container matColumnDef="firstName">-->
<!--                            <mat-header-cell class="tableHeaderCell" *matHeaderCellDef mat-sort-header-->
<!--                                             fxLayoutAlign="start center center"> Όνομα-->
<!--                            </mat-header-cell>-->
<!--                            <mat-cell *matCellDef="let parent"-->
<!--                                      fxLayoutAlign="start center center"> {{parent.firstName}} </mat-cell>-->
<!--                        </ng-container>-->

<!--                        <ng-container matColumnDef="lastName">-->
<!--                            <mat-header-cell class="tableHeaderCell" *matHeaderCellDef mat-sort-header-->
<!--                                             fxLayoutAlign="start center center">-->
<!--                                Επώνυμο-->
<!--                            </mat-header-cell>-->
<!--                            <mat-cell class="tableCell" *matCellDef="let parent"-->
<!--                                      fxLayoutAlign="start center center"> {{parent.lastName}} </mat-cell>-->
<!--                        </ng-container>-->

<!--                        <ng-container matColumnDef="email">-->
<!--                            <mat-header-cell class="tableHeaderCell" *matHeaderCellDef-->
<!--                                             fxLayoutAlign="start center center"> Email-->
<!--                            </mat-header-cell>-->
<!--                            <mat-cell class="tableCell" *matCellDef="let parent"-->
<!--                                      fxLayoutAlign="start center center"> {{parent.email}} </mat-cell>-->
<!--                        </ng-container>-->

<!--                        <ng-container matColumnDef="telephone">-->
<!--                            <mat-header-cell class="tableHeaderCell" *matHeaderCellDef-->
<!--                                             fxLayoutAlign="start center center"> Τηλέφωνο-->
<!--                            </mat-header-cell>-->
<!--                            <mat-cell class="tableCell" *matCellDef="let parent"-->
<!--                                      fxLayoutAlign="start center center"> {{parent.telephone}} </mat-cell>-->
<!--                        </ng-container>-->

<!--                        <ng-container matColumnDef="is_valid">-->
<!--                            <mat-header-cell class="tableHeaderCell" *matHeaderCellDef-->
<!--                                             fxLayoutAlign="start center center"> Κατάσταση-->
<!--                            </mat-header-cell>-->
<!--                            <mat-cell class="tableCell" *matCellDef="let parent"-->
<!--                                      fxLayoutAlign="start center center"> {{+parent.is_valid === 1 ? 'Ενεργός' : 'Ανενεργός'}} </mat-cell>-->
<!--                        </ng-container>-->

<!--                        <ng-container matColumnDef="actions">-->
<!--                            <mat-header-cell class="tableHeaderCell" *matHeaderCellDef-->
<!--                                             fxLayoutAlign="center center center"> Ενέργειες-->
<!--                            </mat-header-cell>-->
<!--                            <mat-cell class="tableCell" *matCellDef="let parent" fxLayoutAlign="center center center">-->
<!--                                <div #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu"-->
<!--                                     style="cursor: pointer; align-content: center;">-->
<!--                                    <div fxLayout="row" fxFlexAlign="center">-->
<!--                                        <mat-icon-->
<!--                                                style="align-content:center; vertical-align: middle; color:var(&#45;&#45;primaryOrange)">-->
<!--                                            {{menuTrigger.menuOpen ? 'expand_less' : 'expand_more'}}-->
<!--                                        </mat-icon>-->
<!--                                    </div>-->
<!--                                </div>-->

<!--                                <mat-menu #menu="matMenu">-->
<!--                                    <mat-list>-->
<!--                                        <mat-list-item class="menuList">-->
<!--                                            <button mat-menu-item (click)="getParentInfo(parent)">-->
<!--                                                <mat-icon class="icon">info</mat-icon>&nbsp;Προβολή πληροφοριών-->
<!--                                            </button>-->
<!--                                        </mat-list-item>-->
<!--                                        <mat-list-item class="menuList">-->
<!--                                            <button mat-menu-item (click)="sendEmail(parent)">-->
<!--                                                <mat-icon class="icon">message</mat-icon>&nbsp;Αποστολή ενημέρωσης-->
<!--                                            </button>-->
<!--                                        </mat-list-item>-->
<!--                                        &lt;!&ndash;                <mat-list-item class="menuList">&ndash;&gt;-->
<!--                                        &lt;!&ndash;                  <button mat-menu-item>&ndash;&gt;-->
<!--                                        &lt;!&ndash;                  <mat-icon class="icon">message</mat-icon>&nbsp;Αποστολή SMS&ndash;&gt;-->
<!--                                        &lt;!&ndash;                  </button>&ndash;&gt;-->
<!--                                        &lt;!&ndash;                </mat-list-item>&ndash;&gt;-->
<!--                                        <mat-list-item class="menuList">-->
<!--                                            <button mat-menu-item (click)="sendMessage(parent)">-->
<!--                                                <mat-icon class="icon">notifications</mat-icon>&nbsp;Αποστολή-->
<!--                                                ειδοποίησης-->
<!--                                            </button>-->
<!--                                        </mat-list-item>-->
<!--                                    </mat-list>-->
<!--                                </mat-menu>-->

<!--                            </mat-cell>-->
<!--                        </ng-container>-->

<!--                        <mat-header-row *matHeaderRowDef="columnsToDisplay"></mat-header-row>-->
<!--                        <mat-row *matRowDef="let record; columns: columnsToDisplay"></mat-row>-->
<!--                    </mat-table>-->

<!--                    <div *ngIf="isLoading">-->
<!--                        <app-skeleton-loading></app-skeleton-loading>-->
<!--                    </div>-->
<!--                    <div fxLayout="row" fxLayoutAlign="end center center">-->
<!--                        <mat-paginator [length]="parents.data.length" [pageSize]="50"-->
<!--                                       [pageSizeOptions]="[10, 50, 100, 200]">-->
<!--                        </mat-paginator>-->
<!--                    </div>-->
<!--                </div>-->


<!--            </div>-->

<!--            <div fxShow.lt-md fxHide.gt-sm fxFlex="grow" fxLayoutAlign="center center center" style="margin-top:20px;">-->

<!--                <div fxLayout="column">-->
<!--                    <div style=" background-color: white; position: -webkit-sticky; z-index: 999; position: sticky; top: 58px;">-->
<!--                        <div fxLayout="row">Γρήγορη αναζήτηση</div>-->
<!--                        <div fxFlexAlign="center" fxLayoutGap="20px">-->
<!--                            <mat-form-field style="width:100%;">-->
<!--                                <mat-label>Κριτήριο Αναζήτησης</mat-label>-->
<!--                                <mat-select [(ngModel)]="simpleSearchSelectedValue">-->
<!--                                    <mat-option *ngFor="let searchField of parentSearchFields"-->
<!--                                                [value]="searchField">{{searchField.label}}</mat-option>-->
<!--                                </mat-select>-->
<!--                            </mat-form-field>-->

<!--                            <mat-form-field style="width:100%;">-->
<!--                                <mat-label></mat-label>-->
<!--                                <input matInput autocomplete="off" [(ngModel)]="searchValue"-->
<!--                                       (keydown)="fastSearch($event) ">-->
<!--                            </mat-form-field>-->
<!--                        </div>-->
<!--                        <button style=" width:100%; background-color: var(&#45;&#45;primary); color: white;" mat-raised-button-->
<!--                                matSuffix aria-label="search" (click)="search()">-->
<!--                            Αναζήτηση-->
<!--                            <mat-icon fxFlexAlign="center" matTooltip="Αναζήτηση">search</mat-icon>-->
<!--                        </button>-->
<!--                    </div>-->

<!--                    <app-loading *ngIf="isLoading"></app-loading>-->

<!--                    <div *ngIf="!isLoading" fxShow.lt-md fxHide.gt-sm fxLayout="column"-->
<!--                         fxLayoutAlign="center center center" class="cardsContainer"-->
<!--                         style="margin-bottom: 60px; margin-top:20px;">-->

<!--                        <mat-card *ngFor="let parent of parents.data" class="smallCard mat-elevation-z5">-->
<!--                            <mat-card-content>-->

<!--                                <div fxLayout="row" class="headerSection">Όνομα</div>-->
<!--                                <div fxLayout="row">{{parent.firstName}}</div>-->

<!--                                <div fxLayout="row" class="headerSection">Επώνυμο</div>-->
<!--                                <div fxLayout="row" class="header">{{parent.lastName}}</div>-->

<!--                                <div fxLayout="row" class="headerSection">Email</div>-->
<!--                                <div fxLayout="row">{{parent.email}}</div>-->

<!--                                <div fxLayout="row" class="headerSection">Τηλέφωνο</div>-->
<!--                                <div fxLayout="row" class="header">{{parent.telephone}}</div>-->

<!--                                <div fxLayout="row" fxLayoutAlign="space-evenly" style="margin-top:10px;">-->
<!--                                    <div fxLayout="column" fxLayoutAlign="center center center"-->
<!--                                         (click)="displayParentInfo(parent)">-->
<!--                                        <div fxLayout="row">-->
<!--                                            <mat-icon>info</mat-icon>-->
<!--                                        </div>-->
<!--                                    </div>-->

<!--                                    <div fxLayout="column" (click)="sendEmail(parent)">-->
<!--                                        <div fxLayout="row">-->
<!--                                            <mat-icon>email</mat-icon>-->
<!--                                        </div>-->
<!--                                    </div>-->

<!--                                    <div fxLayout="column">-->
<!--                                        <div fxLayout="row">-->
<!--                                            <mat-icon>message</mat-icon>-->
<!--                                        </div>-->
<!--                                    </div>-->

<!--                                </div>-->

<!--                            </mat-card-content>-->
<!--                        </mat-card>-->

<!--                        <div fxLayout="row" (click)="loadMore($event)"-->
<!--                             style="margin-top:10px; margin-bottom:20px; color: var(&#45;&#45;secondaryBlue)"-->
<!--                             fxLayoutAlign="center center center">Φόρτωσε περισσότερους-->
<!--                        </div>-->

<!--                    </div>-->

<!--                </div>-->


<!--            </div>-->

            <div *ngIf="showParentInfo">
                <app-user-info *ngIf="showParentInfo" [user]="parentInfo"
                               [providers]="notificationProviders"></app-user-info>
            </div>
        </mat-card-content>
    </mat-card>


</div>
